import Joi from 'joi';
import mediaUrlSchema from '@utils/validate/blocksSchemes/mediaUrlSchema';
const videoSchema = Joi.object({
  type: Joi.string().valid('video').required(),
  code: Joi.string().allow('', null).required(),
  image: mediaUrlSchema.allow(null),
  video: mediaUrlSchema.allow(null),
  thumbnail: mediaUrlSchema.allow(null).required(),
  blur: mediaUrlSchema.allow(null),
  link: Joi.object().allow(null).unknown(true),
  buttonText: Joi.string().allow('', null).required(),
  buttonPosition: Joi.string().allow('', null).required(),
  content: {
    topText: Joi.string().allow('', null).required(),
    topTextColor: Joi.string().allow('', null).required(),
    title: Joi.string().allow('', null).required(),
    titleColor: Joi.string().allow('', null).required(),
    description: Joi.string().allow('', null).required(),
    descriptionColor: Joi.string().allow('', null).required(),
    vertical: Joi.string().allow('', null).required(),
    horizontal: Joi.string().allow('', null).required()
  }
}).unknown(true);
export default videoSchema;